import React, { memo, useEffect, useState } from "react";
import { ParsedCountry, PhoneInput } from "react-international-phone";
import 'react-international-phone/style.css';
import NewImageUpload from "../../../Components/ImageUpload/NewImageUpload";
import { Input } from "../../../Components/AllInput/AllInput";
import { phoneInputCountries, toTitleCase } from "../../../Utils/commonFunctions";
import { ProfileTy } from "../../../Components/AllInput/types";
import { GInfoCard } from "../../../Components/Card/NewInfoCard";
import { EditIcon, InfoMark, LocationIcon, NewMailIcon, VerifiedIcon } from "../../../assests/icons/Icons";
import { Accordion } from "../../../Screen/Consumer/RoofAnalysis/NewSiteAnalyze";
import { useAppSelector } from "../../../ReduxTool/store/hooks";
import { UserAddressTy } from "./UserAddressModal";
 
const NewProfileModal = ({isEditing,setProfileState,profileState,error,handleChange,handleMobileNumber,openEditAddres}:{isEditing:boolean,setProfileState:React.Dispatch<React.SetStateAction<ProfileTy>>,profileState:ProfileTy,error:any,handleChange:(e:any)=>void,handleMobileNumber:(phone: string, country: ParsedCountry)=>void,openEditAddres:()=>void}) => {
   const { user: { address: UserGlobalAddress }, user } = useAppSelector((state) => state.auth);
    const [userAddress, setUserAddress] = useState<UserAddressTy>({ country: "", state: "", city: "", pincode: "", address: "" }); 

  useEffect(() => {
      if (UserGlobalAddress) {
        try {
          // Strict Check 1: Attempt JSON parse just in case it was saved as JSON
          const parsedObj = JSON.parse(UserGlobalAddress); 
          if (typeof parsedObj === "object" && parsedObj !== null) {
            setUserAddress({  country: parsedObj.country || user?.country_mstr?.countryname,  state: parsedObj.state || "", city: parsedObj.city || "", pincode: parsedObj.pincode || "",  address: parsedObj.address || "" });
            return;
          }
        } catch (e) {
          // Strict Check 2: Fallback to comma-separated string mapping (address, city, state, country, pincode)
          // const parts = UserGlobalAddress.split(",");
          // setUserAddress({  address: parts[0]?.trim() || "",  city: parts[1]?.trim() || "",  state: parts[2]?.trim() || "",  country: parts[3]?.trim() || "", pincode: parts[4]?.trim() || ""  });
        }
      } else {
        // Global string is empty
        setUserAddress({ country: user?.country_mstr?.countryname || "", state: "", city: "", pincode: "", address: "" });
      }
    }, [UserGlobalAddress]);
  
 const cardRightContent = () => {
     return (<>
     <button type="button" onClick={()=>openEditAddres()} className=" size-4 flex items-center justify-center" > <EditIcon /> </button>
     </>)
   }

    const cardChildren = ()=>(
        <div className="flex w-full text-sm text-gray-700 gap-3"> 
          <div className="mt-[2px]" >  <LocationIcon /> </div>
          <div className="pr-2 overflow-hidden w-full">
              {/* <h4 className='heading-14-roboto-normal text-nowrap overflow-hidden text-ellipsis h-5'>{projectSetup?.addressline1 || projectSetup.address}</h4> */}
              <h4 className='text-14-inter-medium-info turncate h-5'>{!UserGlobalAddress ? "Address not available" : userAddress?.address}</h4>
              <div className='w-full flex items-center gap-1'>
              {/* <p className="text-12-roboto leading-normal h-4 truncate ">{!UserGlobalAddress ? "City not available" : ` ${userAddress?.city}, ${userAddress?.state}, ${userAddress?.country}, ${userAddress?.pincode}, `} </p> */}
              <p className="text-12-roboto leading-normal h-4 truncate ">{!UserGlobalAddress ? "Save your Address" : ` ${userAddress?.city}, ${userAddress?.state}, ${userAddress?.country}, ${userAddress?.pincode}, `} </p>
               {/* <p className="text-12-roboto leading-normal h-4">{projectSetup?.state ? `${projectSetup?.city}, ${projectSetup?.state}, ${projectSetup?.country}, ${projectSetup?.pincode}` : ``} </p> */}
              </div>
          </div>
         </div>
     )

      const cardFirstChildren = ()=>(
        <div className="flex w-full text-sm text-gray-700 gap-3"> 
         <span className="text-gray-500 pt-1"><NewMailIcon /></span>
            <div className="flex flex-col leading-tight w-full gap-1">
              <span className="text-14-inter-medium-info flex justify-between truncate">{profileState?.userEmail??""} <VerifiedIcon /></span>
              <span className="text-12-inter-normal-info">{"Registered email"}</span>
            </div>
         </div>
     )
   
  return (
    <div className="flex flex-col gap-3">
      <p className="text-roboto-14-400 py-3">The information provided below will reflect on your invoices.</p>
    <div className="grid grid-cols-2 gap-3">

        <GInfoCard noWrap title={<p className="text-12-roboto leading-none flex items-center gap-1 uppercase"> Used for login & invoices  </p>}    children={cardFirstChildren()} /> 
        <GInfoCard noWrap title={<p className="text-12-roboto leading-none flex items-center gap-1 uppercase"> My address </p>} rightContent={cardRightContent()}  children={cardChildren()} /> 

    </div>
      <Accordion isDisable={false} isDisableClick={undefined} key={"generalidforaccorduserprofile"} isOpen={true} title={"Personal Information"} onToggle={()=>{}} maxh="fit-content" >
      <div className="relative flex flex-col"> 
          <div className="relative mt-8 ">
                <NewImageUpload isEditing={isEditing} setProfileState={setProfileState} profileState={profileState} />
          </div>
           <div className="form-containerr grid grid-cols-2 gap-x-3 ">
              <Input error={error?.fname} id={"fname"} label={"First name"} name={"fname"} value={toTitleCase(profileState?.fname??"")} type="text" onChange={handleChange} isRequired={true} disabled={false} />          
              <Input error={error?.lname} id={"lname"} label={"Last name"} name={"lname"} value={toTitleCase(profileState?.lname??"")} type="text" onChange={handleChange} isRequired={true} disabled={false} />          
              {/* <Input error={error?.userEmail} id={"userEmail"} label={"User email"} name={"userEmail"} value={profileState?.userEmail??""} type="email" onChange={handleChange} isRequired={false} disabled={true} /> */}
              <div className={`col-span-2 main-box1 bottom-[12px] group ${isEditing?"mobile-no-disable":"mobile-no-enable"} ${error.userMobile ?"mobile-err-container":""}`} >
                 <label htmlFor={"userMobile"} className={`label-box1 ${error.userMobile && "label-error"} `}>Mobile<span className="text-rose-400 text-lg pl-0.5">*</span></label>
                 <PhoneInput countries={phoneInputCountries} forceDialCode={true} disableFormatting hideDropdown={true} disabled={isEditing}  inputProps={{name: 'userMobile',required: true , autoComplete: 'off',className:`${isEditing?"mobile-disable cursor-not-allowed text-[#999999]":"mobile-enable"}`}} defaultCountry="in" name="userMobile" value={profileState?.userMobile??""}
                 onChange={(phone, { country }) => handleMobileNumber(phone, country)} placeholder=" "
                 className={`signupmobile w-full  ${error.userMobile ? 'error' : ''}`} />
                 {error.userMobile&& <span className={`helper-box1 opacity-100 ${error.userMobile ? "text-rose-400" : ""}`}>{error?.userMobile}</span>}
              </div>       
        </div>
      </div>
      </Accordion> 
    </div>
  );
};
 
export default memo(NewProfileModal);
